import React from 'react';

function normalizeReason(reason) {
  if (!reason) return 'Erro desconhecido.';
  if (typeof reason === 'string') return reason;
  const name = reason.name ? `Nome: ${reason.name}` : '';
  const message = reason.message ? `Mensagem: ${reason.message}` : '';
  const stack = reason.stack ? `Stack:\n${reason.stack}` : '';
  return [name, message, stack].filter(Boolean).join('\n\n') || JSON.stringify(reason);
}

export default function GlobalErrorMonitor() {
  const [errorMessage, setErrorMessage] = React.useState('');

  React.useEffect(() => {
    const handleError = (event) => {
      const nextMessage = normalizeReason(event.error || event.message);
      console.error('[window-error]', event.error || event.message);
      setErrorMessage(nextMessage);
    };

    const handleRejection = (event) => {
      const nextMessage = normalizeReason(event.reason);
      console.error('[unhandled-rejection]', event.reason);
      setErrorMessage(nextMessage);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleRejection);
    };
  }, []);

  if (!errorMessage) return null;

  return (
    <div className="fixed inset-x-3 bottom-3 z-[9999] rounded-xl border border-amber-400/40 bg-slate-950/95 p-3 text-xs text-amber-100 shadow-2xl">
      <p className="font-semibold text-amber-300">Erro global capturado</p>
      <pre className="mt-2 max-h-44 overflow-auto whitespace-pre-wrap break-words">{errorMessage}</pre>
    </div>
  );
}
